import { Address } from './address';
import { ItemStatus } from './item-status';
import { Participant } from './participant';

/*
"TransportCodeData":{
   "required":[
      "id",
      "name",
      "participantData",
      "isOnDemand"
   ],
   "type":"object",
   "properties":{
      "id":{
         "description":"Leitcode-ID",
         "type":"string"
      },
      "name":{
         "description":"Name des Leitcode",
         "type":"string"
      },
      "participantData":{
         "$ref":"#/definitions/ParticipantData",
         "description":"Adress- und Kontaktdaten des Leitcodes"
      },
      "isOnDemand":{
         "description":"Bedarfsbedient",
         "type":"boolean"
      }
   }
}
 */
export class Transport {
  public pickupItemStatus: ItemStatus = ItemStatus.empty;
  public handoverItemStatus: ItemStatus = ItemStatus.empty;

  public started = false;

  constructor(
    public id: string,
    public name: string,
    public participant: Participant,
    public isOnDemand: boolean
  ) { }

  public static fromJSON(json: {
    id: string,
    name: string,
    participantData: any,
    isOnDemand: boolean
  }): Transport {
    if (!json) {
      throw new Error('Transport JSON should not be undefined');
    }
    if (!json.id) {
      throw new Error('Transport JSON should have property: id');
    }
    if (!json.name) {
      throw new Error('Transport JSON should have property: name');
    }
    if (!json.participantData) {
      throw new Error('Transport JSON should have property: participantData');
    }
    if (json.isOnDemand === undefined || json.isOnDemand === null) {
      throw new Error('Transport JSON should have boolean property: isOnDemand');
    }
    return new Transport(
      json.id,
      json.name,
      Participant.fromJSON(json.participantData),
      json.isOnDemand
    );
  }

  // ===== Convenience getters ===== //

  public get address(): Address {
    return this.participant.address;
  }

  public get hasScannedAll(): boolean {
    return this.pickupItemStatus.isComplete && this.handoverItemStatus.isComplete;
  }

  // ===== Public operations ===== //

  public setStatus(status: { pickupItemStatus: ItemStatus, handoverItemStatus: ItemStatus }): Transport {
    this.pickupItemStatus = status.pickupItemStatus;
    this.handoverItemStatus = status.handoverItemStatus;
    return this;
  }

  public matches(other: Transport): boolean {
    return this.id === other.id;
  }
}
